import { translate } from '@/translation/translate.ts';
import { Slide } from '@/eventConfig/types.ts';
import { FC } from 'react';
import { useSaveRegistration } from '@/saveRegistration/useSaveRegistration.ts';

interface OnlineStatusTextProps {
  slide: Slide;
}

export const OnlineStatusText: FC<OnlineStatusTextProps> = ({ slide }) => {
  const { onlineStatus, onlineCheck } = useSaveRegistration();

  const retryOnlineCheck = () => {
    onlineCheck();
  };

  const Failure = (
    <>
      <span>{translate(slide?.onlineCheck?.failure)}</span>
      <div>
        <button onClick={retryOnlineCheck}>{translate(slide?.onlineCheck?.retry)}</button>
      </div>
    </>
  );

  const Nobackend = (
    <>
      <span>{translate(slide?.onlineCheck?.noBackend)}</span>
      <div>
        <button onClick={retryOnlineCheck}>{translate(slide?.onlineCheck?.retry)}</button>
      </div>
    </>
  );

  switch (onlineStatus) {
    case 'unknown':
      return (
        <>
          <span>{translate(slide?.onlineCheck?.checking)}</span>
          <span></span>
        </>
      );
    case 'online':
      return (
        <>
          <span>{translate(slide?.onlineCheck?.success)}</span>
          <span></span>
        </>
      );
    case 'no-backend':
      return Nobackend;
    case 'offline':
      return Failure;
    default:
      return Failure;
  }
};
